import {
  Dialog,
  Slide,
  IconButton,
  DialogTitle,
  DialogContent,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import FaceDetectionCamera from "./FaceDetectionCamera";
import CardDetectionCamera from "./CardDetectionCamera";
import { Box } from "@mui/system";
import CardCaptureCamera from "./CardCaptureCamera";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function PopUp(props) {
  const theme = useTheme();
  const popUpFullscreen = useMediaQuery(theme.breakpoints.down("sm"));

  let camera;
  if (props.faceDetection) {
    camera = (
      <FaceDetectionCamera
        handleClose={props.handleClose}
        handleAlert={props.handleAlert}
        faceDetection={props.faceDetection}
        onTakingImage={props.onTakingImage}
      />
    );
  } else if (props.cardDetection) {
    camera = (
      <CardDetectionCamera
        handleClose={props.handleClose}
        handleAlert={props.handleAlert}
        cardDetection={props.cardDetection}
        onTakingImage={props.onTakingImage}
      />
    );
  } else {
    camera = (
      <CardCaptureCamera
        handleClose={props.handleClose}
        handleAlert={props.handleAlert}
        onTakingImage={props.onTakingImage}
      />
    );
  }

  if (props.tutorialOpen) {
    return (
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        TransitionComponent={Transition}
        maxWidth="sm"
        fullWidth
        fullScreen={popUpFullscreen}
      >
        <DialogTitle>{props.tutorialTitle}</DialogTitle>
        <DialogContent sx={{ paddingBottom: "0.8em" }}>
          {props.tutorialContent}

          <Box sx={{ width: "100%", marginTop: "0.5em", display: "flex" }}>
            <Button
              variant="contained"
              component="span"
              sx={{ marginLeft: "auto", marginRight: "auto" }}
              onClick={props.tutorialChangeStep}
            >
              Tôi đã hiểu
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        TransitionComponent={Transition}
        maxWidth="lg"
        fullWidth
        fullScreen={popUpFullscreen}
        sx={{
          "& .MuiDialog-paper": {
            paddingTop: 0,
            paddingBottom: 0,
            maxHeight: "100%",
          },
        }}
      >
        <DialogTitle>
          {props.popUpTitle}
          <IconButton
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            edge="start"
            color="inherit"
            onClick={props.handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "0.8em" }}>{camera}</DialogContent>
      </Dialog>
    );
  }
}
